<!-- @format -->

<ng-container *transloco="let t">
  @if (searchResult) {
    @if (!searchResult.truncated) {
      <fudis-heading [id]="id" [level]="resultHeadingLevel" tabindex="-1" class="fudis-mt-md fudis-mb-sm" data-cy="search-result-counts">
        @if (searchResult.total === 1) {
          <span>{{ t("SEARCH_RESULTS.ONE_RESULT") }}</span>
        }
        @if (searchResult.total > 1) {
          @if (showMoreEnabled) {
            @if (searchResult.total <= searchResult.limit) {
              <span>{{ t("SEARCH_RESULTS.ALL_RESULTS_SHOWN", { count: searchResult.total }) }}</span>
              @if (isShowLess()) {
                <ng-container *ngTemplateOutlet="showMoreOrLessResultsTpl" />
              }
            } @else {
              <span>{{
                t("SEARCH_RESULTS.ALL_RESULTS_NOT_SHOWN", {
                  totalCount: searchResult.total,
                  count: searchResult.limit,
                })
              }}</span>
              @if (searchResult.total >= MAX_SEARCH_LIMIT && searchResult.limit >= MAX_SEARCH_LIMIT) {
                {{ t("SEARCH_RESULTS.TOO_MANY_RESULTS") }}
              }
              @if (searchResult.limit < MAX_SEARCH_LIMIT || isShowLess()) {
                <ng-container *ngTemplateOutlet="showMoreOrLessResultsTpl" />
              }
            }
          } @else {
            <span>{{ t("SEARCH_RESULTS.ALL_RESULTS_SHOWN", { count: searchResult.total }) }}</span>
          }
        }
      </fudis-heading>
    }
  }

  <ng-template #showMoreOrLessResultsTpl>
    <span>&nbsp;</span>
    <sis-button [link]="true" (clicked)="showMoreOrLessResults()">
      @if (isShowLess()) {
        <span>{{ t("SEARCH_RESULTS.SHOW_LESS_RESULTS") }}</span>
      } @else {
        <span>{{ t("SEARCH_RESULTS.SHOW_MORE_RESULTS") }}</span>
      }
    </sis-button>
  </ng-template>
</ng-container>
